import {
    CHANGE_DS_RSLTCS,
    DEL_DS_RSLTCS,
    DEL_ALLDS_RSLTCS,
    CHANGE_CSLINE,
    CHANGE_ELVDEPRDO,
    CHANGE_YLINECHK,
    CHANGE_BORINGCHK,
    CHANGE_WLCHK,
    CHANGE_PROBCHK,
    CHANGE_XSCALE,
    CHANGE_YSCALE,
    CHANGE_YLINE,
    CHANGE_BWIDTH,
    CHANGE_XLIST,
    CHANGE_YLIST,
    CHANGE_YLINELIST,
    CHANGE_WLLINELIST,
    CHANGE_BLIST,
    CHANGE_BLIST2,
    CHANGE_PROBLIST,
    RESET_CELL,
    CLICK_CELL,
    CHANGE_CELLID,
    SCR_TOP,
    SCR_LEFT
} from './actions';

export const redYLine = 10;

const initData = {
    //断面推定結果
    //ido_ID = 井戸ID
    //flg = 折れ点
    //lon = 経度
    //lat = 緯度
    //dist = 距離(幅)
    //GL = 地点標高
    //WL = 地下水位
    //geo = [[地質層厚, 地質カラーID, 予測時の確率リスト]]
    data: [
        {
            ID: 9999,
            data: [
                {
                    "ido_ID": 1,
                    "flg": 1,
                    "lon": 141.345,
                    "lat": 43.019,
                    "dist": 204.1170764717,
                    "GL": 50.0,
                    "WL": 40.0,
                    "geo": [
                        [
                            1.0,
                            11.0,
                            [0.1, 0.8, 0.2, 0.3, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1]
                        ],
                        [
                            1.0,
                            4.0,
                            [0.2, 0.9, 0.4, 0.5, 0.3, 0.3, 0.1, 0.2, 0.1, 0.2, 0.1, 0.9, 0.6]
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            9.0
                        ],
                        [
                            1.0,
                            9.0
                        ],
                        [
                            1.0,
                            9.0
                        ],
                        [
                            1.0,
                            9.0
                        ],
                        [
                            1.0,
                            9.0
                        ],
                        [
                            1.0,
                            9.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            12.0
                        ],
                        [
                            1.0,
                            4.0
                        ]
                    ]
                },
                {
                    "ido_ID": 1,
                    "flg": 0,
                    "lon": 141.34733333333332,
                    "lat": 43.01833333333334,
                    "dist": 204.1170764717,
                    "GL": 51.7,
                    "WL": 30.0,
                    "geo": [
                        [
                            1.0,
                            11.0
                        ],
                        [
                            1.0,
                            1.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ]
                    ]
                },
                {
                    "ido_ID": 1,
                    "flg": 3,
                    "lon": 141.34966666666668,
                    "lat": 43.01766666666666,
                    "dist": 204.1170764717,
                    "GL": 52.9,
                    "WL": 22.9,
                    "geo": [
                        [
                            1.0,
                            4.0
                        ],
                        [
                            1.0,
                            1.0
                        ],
                        [
                            1.0,
                            7.0
                        ],
                        [
                            1.0,
                            7.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            7.0
                        ],
                        [
                            1.0,
                            7.0
                        ],
                        [
                            1.0,
                            7.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ],
                        [
                            1.0,
                            8.0
                        ]
                    ]
                },
                //                {
                //                    "ido_ID": 2,
                //                    "flg": 1,
                //                    "lon": 141.352,
                //                    "lat": 43.016999999999996,
                //                    "dist": 163.0369683934614,
                //                    "GL": 49.4,
                //                    "WL": 39.4,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            9.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ]
                //                    ]
                //                },
                //                {
                //                    "ido_ID": 3,
                //                    "flg": 1,
                //                    "lon": 141.35399999999996,
                //                    "lat": 43.016999999999996,
                //                    "dist": 244.55545248586273,
                //                    "GL": 61.7,
                //                    "WL": 51.7,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            10.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ]
                //                    ]
                //                },
                //                {
                //                    "ido_ID": 3,
                //                    "flg": 0,
                //                    "lon": 141.35699999999997,
                //                    "lat": 43.016999999999996,
                //                    "dist": 244.55545248586273,
                //                    "GL": 60.2,
                //                    "WL": 50.2,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            2.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ]
                //                    ]
                //                },
                //                {
                //                    "ido_ID": 3,
                //                    "flg": 0,
                //                    "lon": 141.35999999999999,
                //                    "lat": 43.016999999999996,
                //                    "dist": 244.55545248586273,
                //                    "GL": 63.3,
                //                    "WL": 53.3,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            9.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ]
                //                    ]
                //                },
                //                {
                //                    "ido_ID": 4,
                //                    "flg": 1,
                //                    "lon": 141.363,
                //                    "lat": 43.016999999999996,
                //                    "dist": 244.5554525899716,
                //                    "GL": 63.4,
                //                    "WL": 53.4,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            11.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ]
                //                    ]
                //                },
                //                {
                //                    "ido_ID": 5,
                //                    "flg": 1,
                //                    "lon": 141.366,
                //                    "lat": 43.016999999999996,
                //                    "dist": 217.38262445216375,
                //                    "GL": 62.6,
                //                    "WL": 52.6,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            13.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            11.0
                //                        ],
                //                        [
                //                            1.0,
                //                            11.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            11.0
                //                        ],
                //                        [
                //                            1.0,
                //                            11.0
                //                        ]
                //                    ]
                //                },
                //                {
                //                    "ido_ID": 5,
                //                    "flg": 0,
                //                    "lon": 141.36866666666668,
                //                    "lat": 43.016999999999996,
                //                    "dist": 217.38262445216375,
                //                    "GL": 85.3,
                //                    "WL": 75.3,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            12.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ]
                //                    ]
                //                },
                //                {
                //                    "ido_ID": 5,
                //                    "flg": 0,
                //                    "lon": 141.37133333333333,
                //                    "lat": 43.016999999999996,
                //                    "dist": 217.38262445216375,
                //                    "GL": 80.0,
                //                    "WL": 70.0,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            12.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            2.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ]
                //                    ]
                //                },
                //                {
                //                    "ido_ID": 6,
                //                    "flg": 1,
                //                    "lon": 141.374,
                //                    "lat": 43.016999999999996,
                //                    "dist": 81.51848420048184,
                //                    "GL": 79.8,
                //                    "WL": 69.8,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            9.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ]
                //                    ]
                //                },
                //                {
                //                    "ido_ID": 7,
                //                    "flg": 3,
                //                    "lon": 141.375,
                //                    "lat": 43.016999999999996,
                //                    "dist": 268.60753400204237,
                //                    "GL": 63.8,
                //                    "WL": 53.8,
                //                    "geo": [
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            6.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            1.0
                //                        ],
                //                        [
                //                            1.0,
                //                            2.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            4.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            8.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            13.0
                //                        ],
                //                        [
                //                            1.0,
                //                            13.0
                //                        ],
                //                        [
                //                            1.0,
                //                            13.0
                //                        ],
                //                        [
                //                            1.0,
                //                            7.0
                //                        ],
                //                        [
                //                            1.0,
                //                            5.0
                //                        ],
                //                        [
                //                            1.0,
                //                            5.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ],
                //                        [
                //                            1.0,
                //                            3.0
                //                        ]
                //                    ]
                //                }
            ]
        }
        ,
        //        {ID: 19999,
        //            data: [
        //                {
        //                    "ido_ID": 1,
        //                    "flg": 1,
        //                    "lon": 141.457722222222,
        //                    "lat": 43.07552777777778,
        //                    "dist": 213.61788818714152,
        //                    "GL": 6.1,
        //                    "WL": -6.1,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            1.0,
        //                            [0.1, 0.8, 0.2, 0.3, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1]
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0,
        //                            [0.1, 0.8, 0.2, 0.3, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1]
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 2,
        //                    "flg": 0,
        //                    "lon": 141.456388888889,
        //                    "lat": 43.07361111111109,
        //                    "dist": 239.021208262976,
        //                    "GL": 7.3,
        //                    "WL": -7.3,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 3,
        //                    "flg": 0,
        //                    "lon": 141.455277777778,
        //                    "lat": 43.072222222222194,
        //                    "dist": 178.8766054502776,
        //                    "GL": 6.8,
        //                    "WL": -6.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 4,
        //                    "flg": 0,
        //                    "lon": 141.4533333333335,
        //                    "lat": 43.07055555666665,
        //                    "dist": 243.65040418084297,
        //                    "GL": 6.8,
        //                    "WL": -6.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 4,
        //                    "flg": 0,
        //                    "lon": 141.451388888889,
        //                    "lat": 43.0688888911111,
        //                    "dist": 243.65040418084297,
        //                    "GL": 6.4,
        //                    "WL": -6.4,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 4,
        //                    "flg": 0,
        //                    "lon": 141.4494444444445,
        //                    "lat": 43.067222225555554,
        //                    "dist": 243.65040418084297,
        //                    "GL": 7.0,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 4,
        //                    "flg": 0,
        //                    "lon": 141.4475,
        //                    "lat": 43.06555556000001,
        //                    "dist": 243.65040418084297,
        //                    "GL": 8.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            11.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.44774074,
        //                    "lat": 43.06368518933334,
        //                    "dist": 208.71012893819417,
        //                    "GL": 9.0,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.44798147999998,
        //                    "lat": 43.06181481866667,
        //                    "dist": 208.71012893819417,
        //                    "GL": 8.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.44822222,
        //                    "lat": 43.059944448,
        //                    "dist": 208.71012893819417,
        //                    "GL": 9.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.44846296,
        //                    "lat": 43.05807407733334,
        //                    "dist": 208.71012893819417,
        //                    "GL": 9.0,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.44870369999998,
        //                    "lat": 43.05620370666667,
        //                    "dist": 208.71012893819417,
        //                    "GL": 9.5,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.44894444,
        //                    "lat": 43.054333336,
        //                    "dist": 208.71012893819417,
        //                    "GL": 8.3,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.44918518,
        //                    "lat": 43.05246296533333,
        //                    "dist": 208.71012893819417,
        //                    "GL": 12.7,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.44942591999998,
        //                    "lat": 43.05059259466667,
        //                    "dist": 208.71012893819417,
        //                    "GL": 11.0,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            13.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.44966666,
        //                    "lat": 43.048722224,
        //                    "dist": 208.71012893819417,
        //                    "GL": 11.6,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            13.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.4499074,
        //                    "lat": 43.04685185333333,
        //                    "dist": 208.71012893819417,
        //                    "GL": 12.3,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.45014813999998,
        //                    "lat": 43.044981482666664,
        //                    "dist": 208.71012893819417,
        //                    "GL": 12.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.45038888,
        //                    "lat": 43.043111112,
        //                    "dist": 208.71012893819417,
        //                    "GL": 14.2,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.45062962,
        //                    "lat": 43.04124074133333,
        //                    "dist": 208.71012893819417,
        //                    "GL": 13.5,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.45087035999998,
        //                    "lat": 43.03937037066666,
        //                    "dist": 208.71012893819417,
        //                    "GL": 14.7,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            11.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 5,
        //                    "flg": 0,
        //                    "lon": 141.4511111,
        //                    "lat": 43.037499999999994,
        //                    "dist": 208.71012893819417,
        //                    "GL": 14.0,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            11.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 6,
        //                    "flg": 0,
        //                    "lon": 141.449583325,
        //                    "lat": 43.035624999999996,
        //                    "dist": 242.67507254977815,
        //                    "GL": 15.5,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            11.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 6,
        //                    "flg": 0,
        //                    "lon": 141.44805555,
        //                    "lat": 43.03375,
        //                    "dist": 242.67507254977815,
        //                    "GL": 16.1,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            11.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 6,
        //                    "flg": 0,
        //                    "lon": 141.446527775,
        //                    "lat": 43.031875,
        //                    "dist": 242.67507254977815,
        //                    "GL": 16.0,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            11.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 6,
        //                    "flg": 0,
        //                    "lon": 141.445,
        //                    "lat": 43.03,
        //                    "dist": 242.67507254977815,
        //                    "GL": 18.5,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 7,
        //                    "flg": 0,
        //                    "lon": 141.44375,
        //                    "lat": 43.027916665000006,
        //                    "dist": 252.8756818008323,
        //                    "GL": 18.2,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 7,
        //                    "flg": 0,
        //                    "lon": 141.4425,
        //                    "lat": 43.02583333000001,
        //                    "dist": 252.8756818008323,
        //                    "GL": 21.3,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.44205,
        //                    "lat": 43.02404999700001,
        //                    "dist": 201.4834763744423,
        //                    "GL": 20.2,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            13.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.4416,
        //                    "lat": 43.022266664000014,
        //                    "dist": 201.4834763744423,
        //                    "GL": 22.0,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.44115,
        //                    "lat": 43.02048333100001,
        //                    "dist": 201.4834763744423,
        //                    "GL": 22.1,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            13.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.4407,
        //                    "lat": 43.01869999800001,
        //                    "dist": 201.4834763744423,
        //                    "GL": 27.7,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.44025,
        //                    "lat": 43.01691666500001,
        //                    "dist": 201.4834763744423,
        //                    "GL": 27.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            13.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.4398,
        //                    "lat": 43.01513333200001,
        //                    "dist": 201.4834763744423,
        //                    "GL": 26.3,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.43935,
        //                    "lat": 43.01334999900001,
        //                    "dist": 201.4834763744423,
        //                    "GL": 27.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.4389,
        //                    "lat": 43.01156666600001,
        //                    "dist": 201.4834763744423,
        //                    "GL": 28.7,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            13.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.43845,
        //                    "lat": 43.00978333300001,
        //                    "dist": 201.4834763744423,
        //                    "GL": 29.4,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 8,
        //                    "flg": 0,
        //                    "lon": 141.438,
        //                    "lat": 43.00800000000001,
        //                    "dist": 201.4834763744423,
        //                    "GL": 31.0,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 9,
        //                    "flg": 0,
        //                    "lon": 141.4382037,
        //                    "lat": 43.00598148,
        //                    "dist": 224.85732020370554,
        //                    "GL": 29.5,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            10.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 9,
        //                    "flg": 0,
        //                    "lon": 141.4384074,
        //                    "lat": 43.003962959999996,
        //                    "dist": 224.85732020370554,
        //                    "GL": 34.4,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 9,
        //                    "flg": 0,
        //                    "lon": 141.4386111,
        //                    "lat": 43.00194443999999,
        //                    "dist": 224.85732020370554,
        //                    "GL": 35.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.43848483636364,
        //                    "lat": 42.99999999636363,
        //                    "dist": 216.2585195429353,
        //                    "GL": 35.1,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.43835857272725,
        //                    "lat": 42.998055552727266,
        //                    "dist": 216.2585195429353,
        //                    "GL": 38.3,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.4382323090909,
        //                    "lat": 42.9961111090909,
        //                    "dist": 216.2585195429353,
        //                    "GL": 40.1,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            11.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.43810604545453,
        //                    "lat": 42.994166665454536,
        //                    "dist": 216.2585195429353,
        //                    "GL": 42.2,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            2.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            6.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.43797978181817,
        //                    "lat": 42.992222221818174,
        //                    "dist": 216.2585195429353,
        //                    "GL": 42.1,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.43785351818178,
        //                    "lat": 42.99027777818181,
        //                    "dist": 216.2585195429353,
        //                    "GL": 44.5,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.43772725454542,
        //                    "lat": 42.98833333454545,
        //                    "dist": 216.2585195429353,
        //                    "GL": 48.1,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            13.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.43760099090906,
        //                    "lat": 42.98638889090909,
        //                    "dist": 216.2585195429353,
        //                    "GL": 48.9,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.4374747272727,
        //                    "lat": 42.98444444727272,
        //                    "dist": 216.2585195429353,
        //                    "GL": 49.0,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            12.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 0,
        //                    "lon": 141.4373484636363,
        //                    "lat": 42.98250000363636,
        //                    "dist": 216.2585195429353,
        //                    "GL": 51.3,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                },
        //                {
        //                    "ido_ID": 10,
        //                    "flg": 2,
        //                    "lon": 141.43722219999995,
        //                    "lat": 42.98055556,
        //                    "dist": 216.2585195429353,
        //                    "GL": 51.8,
        //                    "geo": [
        //                        [
        //                            1.0,
        //                            8.0
        //                        ],
        //                        [
        //                            1.0,
        //                            5.0
        //                        ],
        //                        [
        //                            1.0,
        //                            1.0
        //                        ],
        //                        [
        //                            1.0,
        //                            9.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            4.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            7.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ],
        //                        [
        //                            1.0,
        //                            3.0
        //                        ]
        //                    ]
        //                }
        //            ]
        //        }
    ],
    csLine: 0,
    elvDepRdo: 'dep',
    YLineChk: true,
    boringChk: true,
    wlChk: true,
    probChk: false,
    XScale: '',
    YScale: '',
    YLine: 10,
    bWidth: 20,
    XList: [],
    YList: [],
    YLineList: [],
    wlLineList: [],
    bList: [],
    bList2: [],
    probList: [],
    cellInfo: {
        selIndex: '-',
        dataIndex: '-',
        geoIndex: '-',
        prob: [],
        GL: '-',
        WL: '-',
        elev: '-',
        dep: '-',
        geoID: null
    },
    scrTop: 0,
    scrLeft: 0
};

export function csDspReducer(state = initData, action) {
    switch (action.type) {
        case CHANGE_DS_RSLTCS:
            return changeDsReduce(state, action);
        case DEL_DS_RSLTCS:
            return delDsReduce(state, action);
        case DEL_ALLDS_RSLTCS:
            return delAllDsReduce(state, action);
        case CHANGE_CSLINE:
            return changeCsLineReduce(state, action);
        case CHANGE_ELVDEPRDO:
            return changeElvDepRdoReduce(state, action);
        case CHANGE_YLINECHK:
            return changeYLineChkReduce(state, action);
        case CHANGE_BORINGCHK:
            return changeBoringChkReduce(state, action);
        case CHANGE_WLCHK:
            return changeWlChkReduce(state, action);
        case CHANGE_PROBCHK:
            return changeProbChkReduce(state, action);
        case CHANGE_XSCALE:
            return changeXScaleReduce(state, action);
        case CHANGE_YSCALE:
            return changeYScaleReduce(state, action);
        case CHANGE_YLINE:
            return changeYLineReduce(state, action);
        case CHANGE_BWIDTH:
            return changeBWidthReduce(state, action);
        case CHANGE_XLIST:
            return changeXListReduce(state, action);
        case CHANGE_YLIST:
            return changeYListReduce(state, action);
        case CHANGE_YLINELIST:
            return changeYLineListReduce(state, action);
        case CHANGE_WLLINELIST:
            return changeWlLineListReduce(state, action);
        case CHANGE_BLIST:
            return changeBListReduce(state, action);
        case CHANGE_BLIST2:
            return changeBList2Reduce(state, action);
        case CHANGE_PROBLIST:
            return changeProbListReduce(state, action);
        case RESET_CELL:
            return resetCellReduce(state, action);
        case CLICK_CELL:
            return clickCellReduce(state, action);
        case SCR_TOP:
            return scrTopReduce(state, action);
        case SCR_LEFT:
            return scrLeftReduce(state, action);
        default:
            return state;
    }
}

export function changeDsReduce(state, action) {
    let data = state.data.slice();
    //IDは1オリジン
    data[action.ID - 1] = {
        ID: action.ID,
        data: action.list
    };

    return {
        ...state,
        data: data
    };
}

export function delDsReduce(state, action) {
    return {
        ...state,
        data: state.data.filter((el, index) => {
            return parseInt(index) !== action.rowID;
        })
    };
}

export function delAllDsReduce(state) {
    return {
        ...state,
        data: []
    };
}

export function changeCsLineReduce(state, action) {
    return {
        ...state,
        csLine: action.value
    };
}

export function changeElvDepRdoReduce(state, action) {
    return {
        ...state,
        elvDepRdo: action.value
    };
}

export function changeYLineChkReduce(state, action) {
    return {
        ...state,
        YLineChk: action.checked
    };
}

export function changeBoringChkReduce(state, action) {
    return {
        ...state,
        boringChk: action.checked
    };
}

export function changeWlChkReduce(state, action) {
    return {
        ...state,
        wlChk: action.checked
    };
}

export function changeProbChkReduce(state, action) {
    return {
        ...state,
        probChk: action.checked
    };
}

export function changeXScaleReduce(state, action) {
    return {
        ...state,
        XScale: action.scale
    };
}

export function changeYScaleReduce(state, action) {
    return {
        ...state,
        YScale: action.scale
    };
}

export function changeYLineReduce(state, action) {
    return {
        ...state,
        YLine: action.scale
    };
}

export function changeBWidthReduce(state, action) {
    return {
        ...state,
        bWidth: action.width
    };
}

export function changeXListReduce(state, action) {
    return {
        ...state,
        XList: action.list
    };
}

export function changeYListReduce(state, action) {
    return {
        ...state,
        YList: action.list
    };
}

export function changeYLineListReduce(state, action) {
    return {
        ...state,
        YLineList: action.scale
    };
}

export function changeWlLineListReduce(state, action) {
    return {
        ...state,
        wlLineList: action.wlLineList
    };
}

export function changeBListReduce(state, action) {
    return {
        ...state,
        bList: action.list
    };
}

export function changeBList2Reduce(state, action) {
    return {
        ...state,
        bList2: action.list
    };
}

export function changeProbListReduce(state, action) {
    return {
        ...state,
        probList: action.list
    };
}

export function resetCellReduce(state) {
    return {
        ...state,
        cellInfo: {
            selIndex: '-',
            dataIndex: '-',
            geoIndex: '-',
            prob: [],
            GL: '-',
            WL: '-',
            elev: '-',
            dep: '-',
            geoID: null
        }
    };
}

export function clickCellReduce(state, action) {
    return {
        ...state,
        cellInfo: {
            selIndex: action.selIndex,
            dataIndex: action.dataIndex,
            geoIndex: action.geoIndex,
            prob: action.prob,
            GL: action.GL,
            WL: action.WL,
            elev: action.elev,
            dep: action.dep,
            geoID: action.geoID
        }
    };
}

export function scrTopReduce(state, action) {
    return {
        ...state,
        scrTop: action.top
    };
}

export function scrLeftReduce(state, action) {
    return {
        ...state,
        scrLeft: action.left
    };
}
